module.exports = __webpack_public_path__ + "static/media/gameThumbnail12.5eeeedbc.jpg";